import { Box, Card, Container, Typography } from '@mui/material';
// material
import { styled } from '@mui/material/styles';
import { ResetPasswordForm } from '../components/authentication/resetPassword';

import { MHidden } from '../components/@material-extend';
// components
import Page from '../components/Page';
// layouts
import AuthLayout from '../layouts/AuthLayout';
import { useTranslation } from '../common/LocalizationProvider';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: theme.spacing(2, 0, 2, 2),
  backgroundColor: theme.palette.primary.main
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function ResetPassword() {
  const t = useTranslation();
  return (
    <RootStyle title={t('RP_Title')}>
      <AuthLayout />

      <MHidden width="mdDown">
        <SectionStyle>
          <img src="/static/logo.svg" alt="CTO logo" width={160} />
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }} color="white" textAlign="center">
            {t('RP_Quote')}
          </Typography>
          <Typography variant="subtitle1" color="white">
            {t('RP_Quote_Author')}
          </Typography>
        </SectionStyle>
      </MHidden>

      <Container>
        <ContentStyle>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              {t('resetPassword')}
            </Typography>
          </Box>

          <ResetPasswordForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
